import ViewMessage from './components/ViewMessage.jsx'
import Form from './Form/Form.jsx'

function App() {
  return (
    <div align="center" width="50%">
        <Form />
        <br />
        <ViewMessage />
    </div>
  );
}

export default App;
